import React from 'react';
import logo from '../../logo.png';

const Dashboard = props => (
    <img style={{
        margin: 'auto',
        marginTop: '200px',
        display: 'block'
    }} src={logo} alt='Smiley face' height='420' width='500'/>
);

export default Dashboard;
